import { render } from "./PositionsDataChart.vue?vue&type=template&id=60873b8e&scoped=true"
import script from "./PositionsDataChart.vue?vue&type=script&lang=js"
export * from "./PositionsDataChart.vue?vue&type=script&lang=js"

import "./PositionsDataChart.vue?vue&type=style&index=0&id=60873b8e&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60873b8e"]])

export default __exports__